import React, { useCallback, useContext, useState } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import metadata from './ConfirmationStep.metadata.json5';
import TWIABuildingLocationAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingLocationAccordion/TWIABuildingLocationAccordion';
import TWIABuildingInfoAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingInfoAccordion/TWIABuildingInfoAccordion';
import TWIABuildingConstructionAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingConstructionAccordion/TWIABuildingConstructionAccordion';
import TWIABuildingCoveragesAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingCoveragesAccordion/TWIABuildingCoveragesAccordion';
import TWIABuildingAdditionalInterestsAccordion from '../../TWIABuildingSummaryAccordions/TWIABuildingAdditionalInterestsAccordion/TWIABuildingAdditionalInterestsAccordion';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';


function ConfirmationStep(props) {
    const { handleDoneClick, handleEditLinkClick, handleAnotherClick, selectedBuilding, submissionVM } = props;
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const [buildingVM, setBuildingVM] = useState(selectedLocation.buildings.children[selectedBuildingIndex]);
    const buildingId = _.get(buildingVM, 'publicID.value'); 

    const handleConfirmClick = useCallback(() => {
        handleDoneClick(setSelectedLocation)
    }, [handleDoneClick, setSelectedLocation])

    const resolvers = {
        resolveClassNameMap: wizardStyles,
        resolveCallbackMap: {
            handleDoneClick: handleConfirmClick,
            handleAnotherClick
        },
        resolveComponentMap: {
            TWIABuildingLocationAccordion,
            TWIABuildingInfoAccordion,
            TWIABuildingConstructionAccordion,
            TWIABuildingCoveragesAccordion,
            TWIABuildingAdditionalInterestsAccordion
        }
    }

    const overrideProps = {
        locationAccordion: {
            handleEditLinkClick,
            isConfirmationStep: true
        },
        buildingAccordion: {
            handleEditLinkClick,
            isConfirmationStep: true
        },
        constructionAccordion: {
            handleEditLinkClick,
            isConfirmationStep: true
        },
        coveragesAccordion: {
            handleEditLinkClick,
            isConfirmationStep: true,
            fromBuilding: false
        },
        additionalInterestsAccordion: {
            handleEditLinkClick,
            isConfirmationStep: true,
            submissionVM,
            buildingId,  
        },
        addAnotherBuilding: {
            visible: selectedBuilding?.coverageForm !== 'TWCR'
        }
    }

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            resolveCallbackMap={resolvers.resolveCallbackMap}
            resolveClassNameMap={resolvers.resolveClassNameMap}
            resolveComponentMap={resolvers.resolveComponentMap}
            overrideProps={overrideProps}
        />
    )
}

export default ConfirmationStep